import { getProductType, type TicketData } from '@/api/registration';
import { useCartQuery } from './useCartQuery';
import { useMemo } from 'react';
import { useEventSettingsQuery } from './useEventSettingsQuery';
import { useRegisterRoute } from './useRegisterRoute';

export function useIsAlreadyInCart(ticket: TicketData) {
  const { eventId } = useRegisterRoute();
  const { data: cart } = useCartQuery(eventId);
  const { data: eventSetting } = useEventSettingsQuery(eventId);
  const result = useMemo(
    () => {
      if (eventSetting?.groupRegistration.isEnabled) return false; // group registration can buy multiple ticket
      return !!cart?.cartItems
        .find((cartItem) => { return (cartItem.productId === ticket.id && cartItem.productType === getProductType(ticket.type)); });
    }, [cart?.cartItems, eventSetting?.groupRegistration, ticket.id, ticket.type]);
  return result;
}
